import React from 'react';
import { Wrench, Truck, Shield, Headphones, ArrowRight } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Asesoría Técnica',
    desc: 'Te ayudamos a elegir las herramientas y materiales ideales para tu proyecto. Nuestro equipo de expertos está disponible para resolver todas tus dudas.',
    icon: Headphones,
    price: 'Gratis'
  }, {
    title: 'Instalación de Cerraduras',
    desc: 'Servicio profesional de instalación de cerraduras, manillas y sistemas de seguridad para puertas residenciales y comerciales.',
    icon: Shield,
    price: 'Desde $25'
  }, {
    title: 'Envío a Domicilio',
    desc: 'Realizamos envíos a toda Venezuela. Entrega rápida y segura de todos tus productos directamente en tu hogar u obra.',
    icon: Truck,
    price: 'Desde $5'
  }, {
    title: 'Reparación de Herramientas',
    desc: 'Servicio técnico autorizado para reparación de herramientas eléctricas Makita, DeWalt, Bosch y otras marcas reconocidas.',
    icon: Wrench,
    price: 'Presupuesto'
  }];
  return <div className="bg-[#f4f4f4] min-h-screen py-16" data-id="element-620">
      <div className="max-w-7xl mx-auto px-4" data-id="element-621">
        <div className="text-center mb-16" data-id="element-622">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-623">
            Nuestros Servicios
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-624">
            Más que una ferretería, somos tu aliado en cada proyecto. Ofrecemos
            servicios profesionales para garantizar tu satisfacción.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-625">
          {services.map((service, idx) => <div key={idx} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow group" data-id="element-626">
              <div className="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#234d99] transition-colors" data-id="element-627">
                <service.icon className="w-7 h-7 text-[#234d99] group-hover:text-white transition-colors" data-id="element-628" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-629">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-630">
                {service.desc}
              </p>
              <div className="flex items-center justify-between pt-6 border-t border-gray-100" data-id="element-631">
                <span className="font-bold text-[#234d99] text-lg" data-id="element-632">
                  {service.price}
                </span>
                <button className="text-sm font-bold text-gray-900 flex items-center gap-1 hover:gap-2 transition-all" data-id="element-633">
                  Solicitar <ArrowRight className="w-4 h-4" data-id="element-634" />
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}